import React from "react";
import FeatureGenericSkeleton from "./FeatureGenericSkeleton";

function FeatureDetailSkeleton() {
  return (
    <>
      <FeatureGenericSkeleton />
    </>
  );
}

export default FeatureDetailSkeleton;
